import ApiService from "./ApiService";
import GeneralUtils from '../utilities/GeneralUtils';
import ApiUtils from "../utilities/ApiUtils";

export class RecruitmentService {

    async getRecruitmentCampaignList(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/recruitment/campaign/list`, criteria)
                .then(response => {
                    response.data.map((item) => {
                        item.startDate = item.startDate ? new Date(Date.parse(item.startDate)) : '';
                        item.endDate = item.endDate ? new Date(Date.parse(item.endDate)) : '';
                        return item;
                    });

                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveRecruitmentCampaign(campaign) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/recruitment/campaign', campaign)
                .then(response => {
                    response.data.recruitmentCampaign.startDate = response.data.recruitmentCampaign.startDate ? new Date(Date.parse(response.data.recruitmentCampaign.startDate)) : '';
                    response.data.recruitmentCampaign.endDate = response.data.recruitmentCampaign.endDate ? new Date(Date.parse(response.data.recruitmentCampaign.endDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }

    async deleteRecruitmentCampaign(id) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/recruitment/campaign/${id}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getActiveCampaign() {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/recruitment/campaign/active`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeCheckErrorArray(error))
                })
        })
    }

    async getRecruitmentPlan(id) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/recruitment/plan/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeCheckErrorArray(error))
                })
        })
    }

    async getRecruitmentPlanList(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/recruitment/plan/list`, criteria)
                .then(response => {
                    response.data.items.map((item) => {
                        item.deadline = item.deadline ? new Date(Date.parse(item.deadline)) : '';
                        item.registrationDate = item.registrationDate ? new Date(Date.parse(item.registrationDate)) : '';
                        return item;
                    });

                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveRecruitmentPlan(plan) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/recruitment/plan', plan)
                .then(response => {
                    response.data.recruitmentPlan.deadline = response.data.recruitmentPlan.deadline ? new Date(Date.parse(response.data.recruitmentPlan.deadline)) : '';
                    response.data.recruitmentPlan.registrationDate = response.data.recruitmentPlan.registrationDate ? new Date(Date.parse(response.data.recruitmentPlan.registrationDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }

    async validateRecruitmentPlan(plan) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/recruitment/plan/validate', plan)
                .then(response => {
                    response.data.recruitmentPlan.deadline = response.data.recruitmentPlan.deadline ? new Date(Date.parse(response.data.recruitmentPlan.deadline)) : '';
                    response.data.recruitmentPlan.registrationDate = response.data.recruitmentPlan.registrationDate ? new Date(Date.parse(response.data.recruitmentPlan.registrationDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }

    async unlockEditRecruitmentPlan(plan) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/recruitment/plan/editable', plan)
                .then(response => {
                    response.data.recruitmentPlan.deadline = response.data.recruitmentPlan.deadline ? new Date(Date.parse(response.data.recruitmentPlan.deadline)) : '';
                    response.data.recruitmentPlan.registrationDate = response.data.recruitmentPlan.registrationDate ? new Date(Date.parse(response.data.recruitmentPlan.registrationDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }    

    async invalidateRecruitmentPlan(plan) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/recruitment/plan/invalidate', plan)
                .then(response => {
                    response.data.recruitmentPlan.deadline = response.data.recruitmentPlan.deadline ? new Date(Date.parse(response.data.recruitmentPlan.deadline)) : '';
                    response.data.recruitmentPlan.registrationDate = response.data.recruitmentPlan.registrationDate ? new Date(Date.parse(response.data.recruitmentPlan.registrationDate)) : '';
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }

    async deleteRecruitmentPlan(id) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/recruitment/plan/${id}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getRecruitmentPlanJob(id) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().get(`/recruitment/plan/job/${id}`)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    reject(ApiUtils.computeCheckErrorArray(error))
                })
        })
    }

    async getRecruitmentPlanJobList(criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/recruitment/plan/job/list`, criteria)
                .then(response => {
                    response.data.items.map((item) => {
                        item.jobList = item.jobList ? item.jobList : [];
                        return item;
                    });

                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async saveRecruitmentPlanJob(planJob, secret = false) {
        let _planJob = { ...planJob }
        _planJob.recruitmentPlan = { id: planJob.recruitmentPlan.id }
        if (!secret) {
            _planJob.departmentType = planJob.departmentType?.name
            _planJob.departmentName = planJob.departmentName?.name
            _planJob.position = planJob.position?.name
            _planJob.positionClass = planJob.positionClass?.name
            _planJob.positionLevel = planJob.positionLevel?.name
            if (planJob.id) {
                _planJob.jobID = planJob.jobID?.jobID
                _planJob.institutionJob = planJob.jobList[0] ? planJob.jobList[0] : planJob.jobList
                _planJob.jobList = []
            } else {
                _planJob.jobID = null
            }
        } else {
            _planJob.institutionJob = null
        }

        // console.log("save recruitment plan job: ", _planJob)
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post('/recruitment/plan/job', _planJob)
                .then(response => {
                    resolve(GeneralUtils.emptyInNullForObjectFields(response.data))
                })
                .catch(error => {
                    reject(ApiUtils.computeSaveErrorArray(error))
                })
        })
    }

    async deleteRecruitmentPlanJob(id) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().delete(`/recruitment/plan/job/${id}`)
                .then(resolve)
                .catch(error => {
                    let errorMessage = "generic.delete.error";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

    async getRecruitmentPlanJobListForCompetition(competitionId, institutionId, criteria) {
        return new Promise((resolve, reject) => {
            ApiService.getAuthenticatedInstance().post(`/recruitment/plan/job/list/for-competition/${competitionId}/institution/${institutionId}`, criteria)
                .then(response => {
                    response.data.items.map((item) => {
                        return item;
                    });

                    resolve(response.data)
                })
                .catch(error => {
                    let errorMessage = "generic.error.get.data";
                    if (error && error.response && error.response.data && error.response.data.message) {
                        errorMessage = error.response.data.message
                    }
                    reject(errorMessage)
                })
        })
    }

}